module.exports = __webpack_public_path__ + "fb9e67436f6a3284c347a06c2a9880c7.svg";